import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

interface PricingItem {
  name: string;
  price: string;
  description?: string;
}

interface PricingCategory {
  title: string;
  items: PricingItem[];
}

const TarifsPage: React.FC = () => {
  const pricingCategories: PricingCategory[] = [
    {
      title: "Étang des Vernes",
      items: [
        {
          name: "Demi-journée",
          price: "20€",
          description: "Pêche pour une demi-journée (matin ou après-midi)"
        },
        {
          name: "Journée complète",
          price: "38€",
          description: "Pêche pour une journée entière, sans limitation de prises"
        }
      ]
    },
    {
      title: "Étang des Roches",
      items: [
        {
          name: "Demi-journée",
          price: "29€",
          description: "Pêche pour une demi-journée (matin ou après-midi)"
        },
        {
          name: "Journée complète",
          price: "58€",
          description: "Pêche pour une journée entière, sans limitation de prises"
        }
      ]
    },
    {
      title: "Plan d'eau pêche à la mouche",
      items: [
        {
          name: "No kill intégral",
          price: "20€",
          description: "Pêche à la mouche avec remise à l'eau obligatoire"
        }
      ]
    },
    {
      title: "Services supplémentaires",
      items: [
        {
          name: "Vente au détail",
          price: "",
          description: "Ventes de truites (10h30 - 17h45)<br /><br />Truite portion (env. 300g)<br /><b>13 €/kg</b><br /><br />Grosse truite (à partir d'1kg)<br /><b>15 €/kg</b><br /><br />Planche de truite fumée (400g, tranchée, désarêtée)<br /><b>20 €</b><br />(soit 50 €/kg)"
        },
        {
          name: "Pêche rapide",
          price: "13 €/kg",
          description: "Environ 15-20min (matériel et appât fourni)"
        },
        {
          name: "Location d'un plan d'eau",
          price: "Sur demande",
          description: "Possibilité de louer un plan d'eau pour une journée"
        }
      ]
    }
  ];

  return (
    <div className="font-body">
      <SEO 
        title="Tarifs"
        description="Consultez les tarifs de nos étangs de pêche au Moulin Tala : Étang des Vernes, Étang des Roches et plan d'eau pour la pêche à la mouche."
        canonicalUrl="https://lemoulintala.fr/tarifs"
        keywords="tarifs pêche morvan, étang des vernes, étang des roches, pêche à la mouche, no kill"
      />

      {/* Header */}
      <div className="bg-primary py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold text-white mb-4 font-heading">Nos Tarifs</h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Découvrez nos différentes formules pour profiter pleinement de nos étangs de pêche
          </p>
        </div>
      </div>

      {/* Pricing Sections */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-16">
            {pricingCategories.map((category, categoryIndex) => (
              <div key={categoryIndex}>
                <h2 className="text-2xl md:text-3xl font-bold mb-8 text-primary border-b-2 border-accent pb-2 inline-block font-heading">
                  {category.title}
                </h2>
                
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {category.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="text-xl font-semibold text-primary font-heading">{item.name}</h3>
                        <span className="text-lg font-bold text-accent">{item.price}</span>
                      </div>
                      {item.description && (
                        <p className="text-darkGray mt-2" dangerouslySetInnerHTML={{ __html: item.description }} />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6 font-heading">Une question sur nos tarifs ?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            N'hésitez pas à nous contacter pour plus d'informations ou pour réserver votre journée de pêche.
          </p>
          <Link 
            to="/contact" 
            className="bg-accent text-dark font-body font-bold px-6 py-3 rounded-md hover:bg-accent/90 transition-colors inline-block"
          >
            Nous contacter
          </Link>
        </div>
      </section>
    </div>
  );
};

export default TarifsPage; 